var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileGeneral = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 48,
  viewBox: "0 0 44 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 24,
  r: 22,
  fill: "#E2E4EB",
  fillOpacity: 0.6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.8179 17.0047C18.2322 17.0047 18.5679 17.3405 18.5679 17.7547C18.5679 18.1689 18.2322 18.5047 17.8179 18.5047H17.0081C13.9708 18.5047 11.5085 20.9669 11.5085 24.0042C11.5085 27.0415 13.9708 29.5038 17.0081 29.5038H17.8179C18.2322 29.5038 18.5679 29.8395 18.5679 30.2538C18.5679 30.668 18.2322 31.0038 17.8179 31.0038H17.0081C13.1423 31.0038 10.0085 27.87 10.0085 24.0042C10.0085 20.1385 13.1424 17.0047 17.0081 17.0047H17.8179ZM25.4905 17.7547C25.4905 17.3405 25.8263 17.0047 26.2405 17.0047H27.0016C30.8674 17.0047 34.0012 20.1385 34.0012 24.0042C34.0012 27.87 30.8674 31.0038 27.0016 31.0038H26.2405C25.8263 31.0038 25.4905 30.668 25.4905 30.2538C25.4905 29.8395 25.8263 29.5038 26.2405 29.5038H27.0016C30.039 29.5038 32.5012 27.0415 32.5012 24.0042C32.5012 20.9669 30.039 18.5047 27.0016 18.5047H26.2405C25.8263 18.5047 25.4905 18.1689 25.4905 17.7547ZM15.9722 23.9815C15.9722 23.5673 16.308 23.2315 16.7222 23.2315H27.2416C27.6558 23.2315 27.9916 23.5673 27.9916 23.9815C27.9916 24.3957 27.6558 24.7315 27.2416 24.7315H16.7222C16.308 24.7315 15.9722 24.3957 15.9722 23.9815Z",
  fill: "#5E5E66"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileGeneral);
export default ForwardRef;